import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-main',
  templateUrl: '../views/activity-main.component.html',
  styleUrls: ['../../../css/activity-main.component.css']
})
export class ActivityMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/activity/components/activity-main.component.ts